import { useSortable } from '@dnd-kit/sortable';
import classNames from 'classnames';
import { Button } from 'components/atoms';
import RadialAudioPlayer from 'components/atoms/audio-player/RadialAudioPlayer';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCircleFill, PiPencilSimpleLine, PiTrash } from 'react-icons/pi';
import { IMusicProductDigitalAlbumTracks } from 'services/music-product-digital/types/form';
import { STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { ISelectOption } from 'types/components/inputs/input.interface';
import { animateLayoutChanges } from 'utils/dnd/dndUtilities';
import './TrackFormCard.scss';

export interface ITrackForm {
  id: string;
  name: string;
  mp3PreviewLink: string;
}

interface ITrackFormCardProps {
  track: IMusicProductDigitalAlbumTracks;
  onGoEdit?: () => void;
  displayMode?: boolean;
  onRemove?: () => void;
  onSelectTrackFromCatalog?: (id: ISelectOption<string | number>) => void;
  index: number;
  sortableKey: string;
}

const TrackFormCard = ({
  track,
  displayMode,
  onRemove,
  onGoEdit,
  sortableKey,
  onSelectTrackFromCatalog,
  index,
}: ITrackFormCardProps) => {
  const { t } = useTranslation();
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: sortableKey,
    animateLayoutChanges,
    disabled: displayMode,
  });

  const style: CSSProperties = {
    // transform: `translate(0px, ${transform?.y}px)`,
    transform: transform
      ? `translateY(${transform.y}px) ${isDragging ? 'scale(1.02)' : ''}`
      : 'none',
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={classNames('track-form-card', { isDragging })}
      style={style}
    >
      <div className="track-form-number">{index + 1}</div>

      {!!track.id.length && (
        <RadialAudioPlayer playerId={track.id} audioSrc={track.mp3PreviewLink ?? ''} size={80} />
      )}

      <div className="track-form-name">
        <div className="track-form-header">{track.name}</div>
        <div className="track-form-footer">
          <div className="track-form-footer-content">
            {track.version}
            {track.version && <PiCircleFill />}
            {t(`enum.STATUS.${STATUS[track.trackStatus]}`)}
          </div>
        </div>
      </div>

      {!displayMode && (
        <>
          {!!track.id.length && (
            <Button isClear onlyIcon onClick={onGoEdit}>
              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          <Button isClear onlyIcon variant={BUTTON_VARIANT.remove} onClick={onRemove}>
            <Button.Icon icon={<PiTrash />} />
          </Button>
        </>
      )}
    </div>
  );
};

export default TrackFormCard;
